import { pagination_params } from '@/shared/utils/pagination_params';

const mapTipos = {
  date: 'date',
  date_range: 'date_range',
  select: 'select',
  multiselect: 'select',
  select_input: 'select_input',
  string: 'input',
  number: 'input_number',
  boolean: 'switch',
};

const mapOperator = {
  date: 'eq',
  date_range: 'gte|lte',
  select: 'eq',
  multiselect: 'eq',
  select_input: 'eq',
  string: 'contains',
  number: 'eq',
  boolean: 'eq',
};

const append = (path, key, val) => {
  if (val === undefined) return path;
  if (val === null || val === '') return `${path ? `${path}&` : ''}${key}`;
  return `${path ? `${path}&` : ''}${key}=${encodeURIComponent(val)}`;
};

export const getParamsUrlCriteria = (params = {}) => {
  let path = '';
  path = pagination_params(params);
  for (const prop in params) {
    if (!params[prop]) continue;
    if (['page', 'limit', 'sort', 'order'].includes(prop)) continue;

    const field = params[prop].field;
    let value = params[prop].value;

    if (value && Array.isArray(value)) {
      if (typeof value[0] === 'object' && value[0][field.fieldKey]) {
        value = value
          .map((v) => v?.[field.fieldKey])
          .filter(Boolean)
          .join('|');
      } else {
        value = value.join('|');
      }
    } else {
      if (value && typeof value === 'object') {
        value = value[field.fieldKey];
      } else {
        if (value && value.split(';').length > 1) {
          const arrayValues = value.split(';');
          value = arrayValues.map((i) => i.trim()).join('|');
        }
        if (value && value.split('|').length > 1) {
          const arrayValues = value.split('|');
          value = arrayValues.map((i) => i.trim()).join('|');
        }
      }
    }
    const prefix = field.prefix || '';
    let key = field.keyTarget || field.key;
    const operator = field.operator;

    if (field.type === 'date_range' && field.keyDesde && field.keyHasta) {
      let attr = key;
      if (prefix !== '') {
        attr = `${prefix}.${key}`;
      }
      if (value.split('|')[0]) {
        let attrGte = attr;
        if (operator !== '') {
          attrGte = `${attr}.gte`;
        }
        path = append(path, attrGte, value.split('|')[0]);
      }
      if (value.split('|')[1]) {
        let attrLte = attr;
        if (operator !== '') {
          attrLte = `${attr}.lte`;
        }
        path = append(path, attrLte, value.split('|')[1]);
      }
    } else if (field.type === 'select_input' && field.keySelect && field.keyInput) {
      if (value.split('|')[0]) {
        let attr = field.keySelect;
        if (prefix !== '') {
          attr = `${prefix}.${field.keySelect}`;
        }
        if (operator !== '') {
          attr = `${attr}.${operator || 'eq'}`;
        }
        path = append(path, attr, value.split('|')[0]);
      }
      if (value.split('|')[1]) {
        let attr = field.keyInput;
        if (prefix !== '') {
          attr = `${prefix}.${field.keyInput}`;
        }
        if (operator !== '') {
          attr = `${attr}.${operator || 'eq'}`;
        }
        path = append(path, attr, value.split('|')[1]);
      }
    } else {
      if (prefix !== '') {
        key = `${prefix}.${key}`;
      }
      if (operator !== '') {
        key = `${key}.${operator || 'eq'}`;
      }
      path = append(path, key, value);
    }
  }
  return path;
};

export const mapAtributosDinamicosToFilters = (atributos) => {
  return atributos.map((atributo) => {
    const properties = {
      key: atributo.Clave,
      label: atributo.Etiqueta,
      type: mapTipos[atributo.Tipo] || 'input',
      placeholder: atributo.Etiqueta,
      span: 5,
      prefix: 'attr',
      operator: mapOperator[atributo.Tipo] || 'eq',
    };

    if (atributo.Opciones && atributo.Opciones.length > 0) {
      properties['opciones'] = atributo.Opciones;
      properties['fieldKey'] = 'Codigo';
      properties['fieldLabel'] = atributo.Opciones[0].Etiqueta;

      if (atributo.Tipo === 'multiselect') {
        properties['multiple'] = true;
      }
    }

    return properties;
  });
};
